import React from 'react';
import { StatusAtividade } from '../models/atividade';
import { COR_STATUS_ATIVIDADE, LABEL_STATUS_ATIVIDADE } from '../utils/labels';

const StatusBadge: React.FC<{ status: StatusAtividade }> = ({ status }) => (
  <span className={`mc-badge mc-badge--${COR_STATUS_ATIVIDADE[status]}`}>{LABEL_STATUS_ATIVIDADE[status]}</span>
);

export default StatusBadge;
